export const liveChat = (function ($) {

    function init() {
        olarkConfigure();
        handleAdditionalButtons();
    }

    function olarkConfigure() {
        // first check if livechat exists in page
        if ($('#olark').length > 0) {
            window.olark.configure("system.localization", "it-IT");
            window.olark.configure('system.hb_show_as_tab', false);
            window.olark.configure('system.hb_show_button_text', false);
            window.olark.configure('system.hb_primary_color', '#96C2E8');
            window.olark.configure('system.hb_dark_theme', false);
        }
    }

    function handleAdditionalButtons() {
        $("[data-livechat-open]").on("click", function (e) {
            e.preventDefault();
            open();
        });
        $("[data-livechat-close]").on("click", function (e) {
            e.preventDefault();
            close();
        });
    }

    function close() {
        window.olark('api.box.hide');
    }

    function open() {
        window.olark('api.box.expand');
    }

    return {
        init: init,
        close: close,
        open: open
    }

})(jQuery);

